namespace $.$$ {

	export class $shm_hitalama_project_codex extends $.$shm_hitalama_project_codex {

		private completion_chime_instance?: $.$shm_hitalama_chime
		private completion_chime_activity = new Map< string, boolean >()
		private static readonly completion_sound_key = 'shm_hitalama_project_codex_completion_sound'

		override chat_tools() {
			return [ this.Completion_sound(), ...super.chat_tools() ]
		}

		@ $mol_mem
		override completion_sound_enabled( next?: boolean ) {
			const key = $shm_hitalama_project_codex.completion_sound_key
			if( next !== undefined ) {
				this.$.$mol_state_local.value( key, next )
				if( next ) this.completion_chime_prime()
				return next
			}
			return this.$.$mol_state_local.value< boolean >( key ) ?? true
		}

		override completion_sound_hint() {
			return this.completion_sound_enabled()
				? 'Отключить звук завершения'
				: 'Включить звук завершения'
		}

		completion_chime() {
			return this.completion_chime_instance ??= new this.$.$shm_hitalama_chime
		}

		completion_chime_prime() {
			this.completion_chime().prime( this.$.$mol_dom_context )
		}

		completion_chime_play() {
			return this.completion_chime().play( this.$.$mol_dom_context )
		}

		completion_chime_event( event: any ) {
			const thread = String( event.params?.threadId || event.params?.thread?.id || '' )
			if( !thread || !this.event_visible( event ) ) return false
			if( event.method === 'thread/archived' || event.method === 'thread/deleted' ) {
				this.completion_chime_activity.delete( thread )
				return false
			}
			if( event.method === 'turn/started' ) {
				this.completion_chime_activity.set( thread, true )
				return false
			}
			if( event.method !== 'thread/activity/changed' ) return false
			const active = Boolean( event.params?.active )
			const previous = this.completion_chime_activity.get( thread )
			this.completion_chime_activity.set( thread, active )
			if( active || previous !== true || !this.completion_sound_enabled() ) return false
			this.completion_chime_play()
			return true
		}

		event_handle( event: any ) {
			const parent = Object.getPrototypeOf( $shm_hitalama_project_codex.prototype ) as any
			parent.event_handle.call( this, event )
			this.completion_chime_event( event )
		}

		override send( next?: Event ) {
			if( next !== undefined ) this.completion_chime_prime()
			return super.send( next )
		}

		override steer( next?: Event ) {
			if( next !== undefined ) this.completion_chime_prime()
			return super.steer( next )
		}

		project_id() {
			return this.$.$mol_state_arg.value( 'project' ) ?? ''
		}

		session_order_scope() {
			return `${ super.session_order_scope() }:${ this.project_id() }`
		}

		project() {
			return this.$.$shm_projects_data.record( this.project_id() )
		}

		width_px() {
			return `${ this.width() }px`
		}

		server_url( next?: string ) {
			const host = this.$.$mol_dom_context.location.host
			const url = host.endsWith( '.158-160-195-195.ip.hyoo.ru' )
				? 'https://codex-dev.158-160-195-195.ip.hyoo.ru'
				: 'http://127.0.0.1:4870'
			this.$.$shm_codex_api.token_provider( url, ()=> this.$.$shm_projects_config.agent_token() )
			return url
		}

		session_prefix() {
			return `[project:${ this.project_id() }] `
		}

		agent_sessions_load( refresh = 0 ) {
			const prefix = this.session_prefix()
			return $mol_wire_sync( $shm_codex_api ).sessions( this.server_url(), refresh, prefix )
		}

		session_visible( session: $shm_codex_api_thread ) {
			return Boolean( session.name?.startsWith( this.session_prefix() ) )
		}

		events_prefixes() {
			return this.session_prefix()
		}

		event_visible( event: any ) {
			const thread = event.params?.threadId || event.params?.thread?.id
			if( !thread ) return true
			if( event.params?.thread ) return this.session_visible( event.params.thread )
			return this.$.$mol_error_fence(
				()=> Boolean( ( this as any ).session_by_id( thread ) ),
				()=> false,
				()=> false,
			)
		}

		session_title( id: string ) {
			const session = ( this as any ).session_by_id( id ) as $shm_codex_api_thread | undefined
			const title = session?.name || session?.preview || `Сессия ${ id.slice( 0, 8 ) }`
			return title.startsWith( this.session_prefix() ) ? title.slice( this.session_prefix().length ) : title
		}

		@ $mol_mem
		session_id( next?: string ) {
			const key = `shm_projects:${ this.project_id() }:codex_session`
			if( next !== undefined ) return this.$.$mol_state_local.value( key, next ) ?? ''
			return this.$.$mol_state_local.value< string >( key ) ?? ''
		}

		session_create_name( title: string ) {
			return `${ this.session_prefix() }${ title }`
		}

		@ $mol_mem
		session_context() {
			return $mol_wire_sync( $shm_projects_goal_api ).session_context( this.project_id() )
		}

		session_create_cwd() {
			return this.session_context().cwd
		}

		async session_create_context_async() {
			// The generic native-async adapter cannot consume a thrown wire
			// Promise. Bridge each cold read before returning the session payload.
			return {
				cwd: await $mol_wire_async( this ).session_create_cwd(),
				instructions: await $mol_wire_async( this ).session_create_instructions(),
			}
		}

		session_create_instructions() {
			const project = this.project()
			return [
				this.session_context().instructions,
				this.consultation_instruction( project?.title ?? this.project_id() ),
			].filter( Boolean ).join( '\n\n' )
		}

		consultation_instruction( title: string ) {
			return [
				`Это консультационная сессия проекта «${ title }».`,
				'Отвечай на вопросы о проекте и его коде кратко и по существу.',
				'Не изменяй файлы и не начинай реализацию из этого окна.',
				'Если пользователь просит внести изменения, предложи открыть вкладку «Разработка» проекта и вставить требования туда.',
			].join( ' ' )
		}

	}

}
